import type { IFlowAction } from 'widgets/Flow'
import {
  allSmartCallFlowActionTypes,
  type ISmartCallFlowActionType,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'
import { AddButtonStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/AddButton/store/AddButtonStore'
import { type SmartCallFlowBuilderStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder'
import { CallEndsStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions'

export const getActions = ({
  getActionById,
  source,
  target,
}: {
  getActionById: SmartCallFlowBuilderStore['getActionById']
  source: string
  target: string
}): ISmartCallFlowActionType[] => {
  const sourceAction = getActionById(source)
  const targetAction = getActionById(target)

  const isHaveParentCallEnds = (action: IFlowAction) => {
    if (action instanceof CallEndsStore) {
      return true
    }
    if (!action.actionStore.parentId) return false
    const parent = getActionById(action.actionStore.parentId)
    if (parent) {
      return isHaveParentCallEnds(parent)
    }
    return false
  }

  if (targetAction instanceof AddButtonStore) return []

  return allSmartCallFlowActionTypes
    .filter((type) => {
      let isValid = true
      if (sourceAction?.actionStore) {
        const sourceStore = sourceAction.actionStore
        const branchIndex = sourceStore.nextIds.indexOf(target)
        const allowedList =
          (branchIndex !== -1 && sourceStore.allowedNextActionsByBranchIndex?.[branchIndex]) ||
          sourceStore.allowedNextActions
        if (allowedList && !allowedList.includes(type)) {
          isValid = false
        }
      }
      if (
        targetAction?.actionStore.allowedBeforeActions &&
        !targetAction?.actionStore.allowedBeforeActions.includes(type)
      ) {
        isValid = false
      }
      return isValid
    })
    .filter((type) =>
      type === 'sendMessage' && sourceAction ? isHaveParentCallEnds(sourceAction) : true
    )
}
